module.exports = __webpack_public_path__ + "img/textAreaBox_bag.61570e29.png";